<template>
  <div>
    管理台免费充值
  </div>
</template>

<script>
  export default {
    name: "recharge-data"
  }
</script>

<style scoped>

</style>
